import { defaultIfNullish } from "../../util/stringUtil";

export const DisplayItem = ({
  label,
  text,
  className,
  defaultText,
  isEditable,
  toDo,
}: {
  label: string | number;
  text: string | number | undefined | null;
  defaultText?: string;
  isEditable?: boolean;
  toDo?: boolean;
  className?: string;
}) => {
  return (
    <>
      <h5 className="form-label">{label}</h5>
      <div
        className={`form-control--value${isEditable ? " is-editable" : ""}${
          toDo ? " todo" : ""
        }${className ? ` ${className}` : ""}`}
      >
        <span className={`${!text && "text-muted"}`}>
          {defaultIfNullish(text, defaultText)}
        </span>
      </div>
    </>
  );
};
